import { useEffect, useState } from 'react';

export function RootPage() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Здесь в будущем инициализируем WebRTC плеер
    // Пока просто эмулируем загрузку
    const t = setTimeout(() => setReady(true), 300);

    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-16">
      <h1 className="text-2xl mb-2">Top Monitor UI</h1>
      <p className="opacity-80 mb-4">Стартовый экран. Сервис работает на localhost и готов к конфигурированию.</p>

      <div className="mb-4 text-sm">
        Состояние:
        {' '}
        <strong>{ready ? 'готово' : 'инициализация…'}</strong>
      </div>
    </div>
  );
}
